import React from 'react';
import { Button, Modal } from "react-bootstrap";

function ChangePasswordUserModal({ closePasswordModal, changePassword, changePasswordModal, errorMessage, formData, handleChangeForm, isRestoring }) {
    return (
        <Modal show={changePasswordModal} onHide={closePasswordModal}>
            <Modal.Header closeButton>
                <Modal.Title>Change Password</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form>
                    <div className="mb-3">
                        <label htmlFor="password" className="form-label">Password</label>
                        <input
                            type="password"
                            className={`form-control ${errorMessage.password ? "is-invalid" : ""}`}
                            id="password"
                            name="password"
                            placeholder="Enter password"
                            value={formData.password}
                            onChange={handleChangeForm}
                        />
                        {errorMessage.password && (
                            <div className="invalid-feedback">{errorMessage.password}</div>
                        )}
                    </div>

                    <div className="mb-3">
                        <label htmlFor="password_confirmation" className="form-label">Confirm Password</label>
                        <input
                            type="password"
                            className={`form-control ${errorMessage.password_confirmation ? "is-invalid" : ""}`}
                            id="password_confirmation"
                            name="confirmPassword"
                            placeholder="Enter Confirm password"
                            value={formData.confirmPassword}
                            onChange={handleChangeForm}
                        />
                        {errorMessage.password_confirmation && (
                            <div className="invalid-feedback">{errorMessage.password_confirmation}</div>
                        )}
                    </div>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={closePasswordModal}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={changePassword} disabled={isRestoring}>
                            {isRestoring ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Changing Password
                                </>
                            ) : (
                                "Change Password"
                            )}
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default ChangePasswordUserModal